export enum EUserRoles {
  SUPER_ADMIN = 99,
  ADMIN = 88,
  FACTORY_ADMIN = 8,
  SALES_MEMBER = 2,
  STAFF = 1,
}
